import type {ToastAction} from 'src/action-creators/toasts';
import type {ToastMessage} from 'src/types/toast';

import {SHOW_TOAST, REMOVE_TOAST} from 'src/action-creators/toasts';


export default (
  state: ToastMessage[] | null | undefined = [],
  action: ToastAction,
): ToastMessage[] => {
  switch (action.type) {
    case SHOW_TOAST:
      // @ts-expect-error - TS2488 - Type 'ToastMessage[] | null' must have a '[Symbol.iterator]()' method that returns an iterator.
      return [...state, action.payload];
    case REMOVE_TOAST:
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      return state.filter((i) => i.id !== action.payload);
  }
  // @ts-expect-error - TS2322 - Type 'ToastMessage[] | null' is not assignable to type 'ToastMessage[]'.
  return state;
};
